import { useContext, useEffect, useState, useRef, useLayoutEffect } from "react";
import { Contexto } from "@Componentes/App";
import * as _api_ from "@Funciones/api";
import * as _f_ from "@Funciones/funciones";
import * as _div_ from "@Elementos/Div";
import * as _ipt_ from "@Elementos/Input";
import * as _btn_ from "@Elementos/Boton";
import * as _anim_ from "@Elementos/Animaciones";
import * as _tabla_ from "@Elementos/Tabla";
import * as _opt_ from "@Elementos/Opciones";
import ModalInformacion from "@ModalInformacion/ModalInformacion";
import Tabla from "@ComponentesCuerpo/Tabla/Tabla";
import Registro from "@ComponentesCuerpo/Registro/Registro";
import Opciones from "@Composicion/Opciones/Opciones";
import "./BloqueTabla.css";

function BloqueTabla(props) {
  const { estilos, elementos } = props.param;
  const { esComputadora } = useContext(Contexto);
  const [ titulo, setTitulo ] = useState(estilos.titulo);
  const [ elementoCabecera, setElementoCabecera ] = useState(elementos.cabecera);
  const [ elementoCuerpo, setElementoCuerpo ] = useState(elementos);
  const [ estiloCabecera, setEstiloCabecera ] = useState(elementos.cabecera);
  const [ estiloCuerpo, setEstiloCuerpo ] = useState(elementos.cuerpo);

  const [componentes, _] = useState({
    input: _ipt_.Input6,
    div: _div_.Div,
    btn: _btn_.Boton,
    tabla: Tabla,
    registro: Registro,
    opciones: Opciones,
  });
  
  useEffect(() => { 
    console.log(props)
  },[])

  return (
    <>
    <div className="BloqueTabla" style={_f_.estilosObjetoVariablesCSS(estilos) }>
      <div className="BloqueTitulo">{titulo ?? "No establecido"}</div>
      
      <div className="BloqueContenido" style={_f_.estilosObjetoVariablesCSS(estilos)} >
        {elementoCuerpo && elementoCuerpo.map((e) => {
          let [tipo, subtipo] = e.tipo.split(" ");
          tipo = tipo ?? "div";
          subtipo = subtipo ?? "";
          // console.log(tipo,subtipo)
          const Elemento = componentes[tipo];
            return (
              <Elemento param={{
                ...(e.texto !== undefined && { elementos: e.texto }),
                ...(e.estilos !== undefined && { estilos: e.estilos }),
                ...(e.texto !== undefined && { texto: e.texto }),
                ...(e.tipo !== undefined && { tipo: e.tipo }),
                ...(e.name !== undefined && { name: e.name }),
                ...(e.props !== undefined && { props: e.props }),
              }}
              />
            );
        })}
      </div>
    </div>
    </>
  )
}
export default BloqueTabla;